import { Moneda } from "@/shared/types/moneda";
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo";
import { PayVentaFERequest } from "../api/create-and-pay-venta-fe";
import { PayVentaRequest } from "../api/pay-venta";
import { mapCondicionPago } from "@/features/facturacion-electronica/utils/condicion-pago-mapper";
import { mapPagosForm } from "./build-create-and-pay-fe-request";
export interface BuildPayVentaFERequestParams {
  pagoRequest: PayVentaRequest;
  monedaBase: Moneda;
  transferenciaMetodos: TransferenciaMetodo[];
  dEst: string;
  dPunExp: string;
  iTipEmi?: number;
  iIndPres?: number;
  dCondTiCam?: number;
  dTiCam?: number;
}

/*function mapMetodoToTipoPago(nombre?: string): FormPago["tipoPago"] {
  const normalized = (nombre || "").toLowerCase();
  if (normalized.includes("efectivo")) return "efectivo";
  if (normalized.includes("cheque")) return "cheque";
  if (normalized.includes("debito") || normalized.includes("débito")) return "tarjeta_debito";
  if (normalized.includes("credito") || normalized.includes("crédito")) return "tarjeta_credito";
  if (normalized.includes("transf") || normalized.includes("banco")) return "transferencia";
  return "efectivo";
}*/

export function buildPayVentaFERequest({
  pagoRequest,
  monedaBase,
  dEst,
  dPunExp,
  iTipEmi = 1,
  iIndPres = 1,
  dCondTiCam = 1,
  dTiCam,
}: BuildPayVentaFERequestParams): PayVentaFERequest {
  const pagosForm = mapPagosForm(pagoRequest);
  const condicionPago = mapCondicionPago({
    condicionOperacion: "contado",
    pagos: pagosForm,
  });

  return {
    pago: pagoRequest,
    dEst,
    dPunExp,
    condicionPago,
    iTipEmi,
    iIndPres,
    iTImp: 1,
    monedaId: pagoRequest.pago.monedaOperacionId,
    dCondTiCam,
    dTiCam: monedaBase.simbolo === 'PYG' ? parseFloat((dTiCam ?? 1).toFixed(2)) : parseFloat((1 / (dTiCam ?? 1)).toFixed(2)),
  }
};
